import { User } from '../types/user';

export const mockUsers: User[] = [
  {
    id: '1',
    name: 'Juan Pérez',
    email: 'juan.perez@example.com',
    role: 'admin',
    phone: '+57 300 123 4567',
    status: 'active',
    createdAt: '2024-01-15T10:00:00Z',
    lastLogin: '2025-11-05T08:30:00Z',
  },
  {
    id: '2',
    name: 'María González',
    email: 'maria.gonzalez@example.com',
    role: 'emprendedor',
    phone: '+57 301 234 5678',
    company: 'Artesanías MG',
    status: 'active',
    createdAt: '2024-02-20T14:30:00Z',
    lastLogin: '2025-11-04T16:45:00Z',
  },
  {
    id: '3',
    name: 'Carlos Rodríguez',
    email: 'carlos.rodriguez@example.com',
    role: 'emprendedor',
    phone: '+57 302 345 6789',
    company: 'Tech Solutions',
    status: 'active',
    createdAt: '2024-03-10T09:15:00Z',
    lastLogin: '2025-11-03T11:20:00Z',
  },
  {
    id: '4',
    name: 'Ana Martínez',
    email: 'ana.martinez@example.com',
    role: 'organizador',
    phone: '+57 303 456 7890',
    company: 'Eventos Colombia',
    status: 'active',
    createdAt: '2024-04-05T11:00:00Z',
    lastLogin: '2025-11-05T09:00:00Z',
  },
  {
    id: '5',
    name: 'Pedro Sánchez',
    email: 'pedro.sanchez@example.com',
    role: 'emprendedor',
    phone: '+57 304 567 8901',
    company: 'Café Premium',
    status: 'pending',
    createdAt: '2024-11-01T15:30:00Z',
  },
  {
    id: '6',
    name: 'Laura Torres',
    email: 'laura.torres@example.com',
    role: 'emprendedor',
    phone: '+57 305 678 9012',
    company: 'Moda Sostenible',
    status: 'inactive',
    createdAt: '2024-05-20T13:45:00Z',
    lastLogin: '2025-09-15T10:30:00Z',
  },
];
